<template>
  <div>
    <!-- 基础说明，敬请期待.... -->
    <!-- <SentimentPopularTrend  zoom_start="70"></SentimentPopularTrend> -->
    <b-card
      title="人气"
      img-src="http://stock.ziruxing.com/robot/static/manual.png"
      img-alt="Image"
      img-top
      tag="article"
      style="max-width: 800px"
      class="float-left"
    >
      <b-card-text> 如图 </b-card-text>
    </b-card>
  </div>
</template>

<script>
// import SentimentPopularTrend from 'components/sentiment/SentimentPopularTrend.vue'
export default {
  data() {
    return {};
  },
  computed: {},
  components: {
    // SentimentPopularTrend
  },
  methods: {},
};
</script>

<style>
</style>
